import React from "react"

class CampCampersSearch extends React.Component {
  render() {
    return <div>CAMP CAMPERS SEARCH</div>
  }
}

export default CampCampersSearch



// WEBPACK FOOTER //
// ./src/scenes/Camp/CampCampersSearch/index.js